export default "__VITE_ASSET__DqQOV3Uh__"